'use strict';

import util from '../../util';
import shipping from './shipping';


function updatePlaceholderCountryChange() {
    $('select[id$="_country"]').on('selectmenuchange change',function(){
        if ($(this).val()) {
            const countryValue = $(this).val();
            const optionFlagValue = $('.input-select.country').find('.flag-' + countryValue.toLowerCase());
            const placeholderCity = optionFlagValue.attr('data-placeholder');
            const placeholderPhone = optionFlagValue.attr('data-phone');
            const placeholderPostal = optionFlagValue.attr('data-postal');

            // Update city placeholder value with the changed country
            const nearestFieldSet = $(this).closest('fieldset');
            nearestFieldSet.find('.input-text.city').attr('placeholder', placeholderCity);
            nearestFieldSet.find('.input-text.phonenumber').attr('placeholder', placeholderPhone);
            nearestFieldSet.find('.input-text.postal').attr('placeholder', placeholderPostal);
        }
    });

    //For BE,DE and ROE markets, the placeholder should be empty if no country is selected from dropdown
    $(document).ready(function () {
        if($('.country').hasClass('input-select')) {
            const countryVal = $('.input-select.country').val();
            const nearestFieldSet = $('.input-select.country').closest('fieldset');
            if(!countryVal) {
                nearestFieldSet.find('.input-text.city').attr('placeholder', '');
                nearestFieldSet.find('.input-text.phonenumber').attr('placeholder', '');
                nearestFieldSet.find('.input-text.postal').attr('placeholder', '');
            }
        }
    });
}

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
export default {
    init : function () {
        var $form = $('.address');    
        
        // select address from list
        $('select[name$="_addressList"]', $form).on('change', function () {
            var selected = $(this).children(':selected').first();
            var selectedAddress = $(selected).data('address');
            if (!selectedAddress) { return; }
            util.fillAddressFields(selectedAddress, $form);
            shipping.updateShippingMethodList();
            // re-validate the form
            $form.validate().form();
        });
        
        updatePlaceholderCountryChange();
        util.getPhoneNumWithCode();
        util.editPhoneNumberWithCode();
    }
};
